import PolicyDocumentPage from '../components/PolicyDocumentPage';

/**
 * Public Privacy Policy page at `/privacy` (tasks 422, 441).
 *
 * Rendered on the public branch in App.tsx — reachable pre-auth (from the
 * Keycloak registration page, task 421) and pre-consent (from the ConsentGate
 * interstitial). Renders the current PUBLISHED document from AMS via the
 * innovate-service public proxy — the exact text the consent ledger's
 * `(privacy_policy, version)` rows refer to.
 */
export default function PrivacyPolicyPage() {
  return <PolicyDocumentPage type="privacy_policy" title="Privacy Policy" />;
}
